<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="ipqcChecks/templateList"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="模板编码">
            <el-input v-model.trim="filter.templateCode" placeholder="请输入模板编码" clearable/>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入模板名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <ipqc-template-edit ref="ipqcTemplateEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import IpqcTemplateEdit from "@/views/inspection/ipqcCheck/IpqcTemplateEdit";

  export default {
    name: "IpqcTemplateList",
    components: { IpqcTemplateEdit, viewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(0),
          editAuth: this.$auth(0),
          delAuth: this.$auth(0),
        },
        filter: {
          templateCode: "",
          templateName: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "templateCode",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                    fontWeight: "bold",
                  },
                  on: {
                    click: () => {
                      this.$refs.ipqcTemplateEdit.open(params.row, true);
                    },
                  },
                },
                params.row.templateCode,
              );
            },
          },
          {
            tooltip: true,
            key: "templateName",
            align: "center",
            width: 220,
          },
          {
            tooltip: true,
            key: "periodText",
            align: "center",
            minWidth: 320,
          },
          {
            tooltip: true,
            key: "isEnabled",
            align: "center",
            width: 100,
            render: (h, params) => {
              return h("span", params.row.isEnabled === 1 ? "启用" : "停用");
            },
          },
          {
            tooltip: true,
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 160,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.ipqcTemplateEdit.open(row);
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.post("basic", "ipqcChecks/template/delete", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
